import { authenticate } from '@actions/auth';
import {
  fetchEducatorLiveClassURL,
  fetchGoLiveDetails
} from '@actions/educator';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import EducatorLiveClass from '@educator/Container/EducatorLiveClass/EducatorLiveClass';
import { useDispatchToStore } from '@hooks/reduxHooks';
import cookies from '@utils/cookies';
import pushRoute from '@utils/pushRoute';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import styled from 'styled-components';

const LoaderWrapper = styled.div`
  text-align: center;
  grid-column: 1 / 25;
`;
const EducatorLiveClassPage = ({ accessToken, uid, isExternal }) => {
  const dispatch = useDispatchToStore();
  useEffect(() => {
    if (accessToken) {
      cookies.setCookie('accessToken', accessToken, 3024000, true);
      dispatch(authenticate({ accessToken }));
      if (isExternal) {
        pushRoute(
          '/educator/live/[classUID]?external=1',
          `/educator/live/${uid}?external=1`
        );
      } else {
        pushRoute('/educator/live/[classUID]', `/educator/live/${uid}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return accessToken ? (
    <LoaderWrapper>
      <CircularLoader />
    </LoaderWrapper>
  ) : (
    <EducatorLiveClass />
  );
};

EducatorLiveClassPage.pageInfo = {
  layoutOptions: {
    hideNudges: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default EducatorLiveClassPage;

EducatorLiveClassPage.getInitialProps = async ({ store, isServer, query }) => {
  if (query?.token) {
    const { result } = await store.dispatch(fetchGoLiveDetails(query.token));
    if (result?.token && result?.uid) {
      const isExternal = query?.external === '1';
      const { token: accessToken, uid } = result;
      return { accessToken, uid, isExternal };
    }
  }
  if (store.getState().auth.accessToken && !query?.token) {
    await store.dispatch(fetchEducatorLiveClassURL());
  }
  return { isServer };
};

EducatorLiveClassPage.propTypes = {
  accessToken: PropTypes.objectOf(PropTypes.any),
  uid: PropTypes.objectOf(PropTypes.any),
  isExternal: PropTypes.bool
};

EducatorLiveClassPage.defaultProps = {
  accessToken: null,
  uid: null,
  isExternal: false
};
